interface PiKeycapProps {
  children: React.ReactNode;
}

/**
 * The bordered key glyph used in the browse dialogs' footer legends and beside
 * their search fields. Deliberately not used inside a filled primary button —
 * a boxed cap in a filled button reads as two competing containers, so the
 * Enter affordance there is a bare ↵ glyph instead.
 */
export default function PiKeycap({ children }: PiKeycapProps) {
  return (
    <span className="inline-flex items-center justify-center min-w-[20px] h-[20px] px-[5px] rounded-[4px] border border-creator-border text-[10px] leading-none text-creator-text-sub">
      {children}
    </span>
  );
}
